import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Grid, CircularProgress, Alert, AlertTitle } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import serviceFaturaCliente from "../../../../services/serviceFaturaCliente";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Loader, Dashed } from "./styles";
import DialogConfirm from "../../../../components/confirmationDialog";
export interface IDialogProps {
    open: boolean;
    onClose?: any;
    onCancel?: any;
    idProp?: any;
}

const schema = yup.object().shape({
    motivo: yup.string().required(messages.requiredField),
});

export default function DialogReopen({ open, onClose, onCancel, idProp }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [openModalFaturaPaga, setOpenModalFaturaPaga] = useState(false);
    const [prosseguirPendenciaSankhya, setProsseguirPendenciaSankhya] = useState(false);
    const [msgRetornoPendenciaSankhya, setMsgRetornoPendenciaSankhya] = useState("");
    const [loadingElegibilidade, setLoadingElegibilidade] = useState(false);
    const [permiteRefaturamento, setPermiteRefaturamento] = useState(false);
    const [descricaoRefaturamento, setDescricaoRefaturamento] = useState("");
    const [errosElegibilidade, setErrosElegibilidade] = useState<string[]>([]);
   
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (open && idProp?.id) {
            setLoadingElegibilidade(true);
            setPermiteRefaturamento(false);
            setDescricaoRefaturamento("");
            setErrosElegibilidade([]);

            serviceFaturaCliente
                .getElegibilidadeRefaturamento(idProp.id)
                .then((result) => {
                    if (result && result.status === 200) {
                        const data = result.data;
                        setPermiteRefaturamento(true);
                        setDescricaoRefaturamento(data.descri\u00e7\u00e3oRefaturamento ?? data.descricaoRefaturamento ?? "");
                        if (data.errors && data.errors.length > 0) {
                            setErrosElegibilidade(data.errors);
                        }
                    }
                })
                .catch(() => {
                    setPermiteRefaturamento(true);
                    setDescricaoRefaturamento("");
                    toast.error("Erro ao consultar elegibilidade de refaturamento.");
                })
                .finally(() => {
                    setLoadingElegibilidade(false);
                });
        }
    }, [open, idProp?.id]);

    const onSubmit = async (values: any) => {        
        setDisable(true);

        const reopenValues = {
            ...values,
            id: idProp.id,
            prosseguirPendenciaSankhya: prosseguirPendenciaSankhya
        };

        serviceFaturaInstalacao
            .reopen(reopenValues)
            .then((result) => {
                if (result && result.status === 200) {
                    if (result && result.data?.mensagemRetornoSankhya && result.data?.mensagemRetornoSankhya !== "") {
                        setMsgRetornoPendenciaSankhya(result.data?.mensagemRetornoSankhya);
                        setOpenModalFaturaPaga(true);                       
                    }
                    else{
                        toast.success("Fatura reaberta com sucesso!");
                        reset();
                        onClose(true);
                    }
                }
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const onCancelReopen = () => {
        reset();
        onCancel(true);
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onCancel();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Reabrir Fatura                  
                    <IconButton
                        aria-label="close"
                        onClick={onCancel}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {isDisable && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>

                        {loadingElegibilidade ? (
                            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={4}>
                                <CircularProgress size={40} sx={{ color: "#019BBE", mb: 2 }} />
                                <Typography variant="body1" sx={{ fontFamily: "'Lato', sans-serif", color: "#555" }}>
                                    Consultando elegibilidade de Refaturamento da Fatura Instalação de id {idProp?.id}...
                                </Typography>
                            </Box>
                        ) : (
                            <>
                                {!permiteRefaturamento && (
                                    <Alert 
                                        severity="warning" 
                                        sx={{ 
                                            mb: 2, 
                                            backgroundColor: '#fff3cd', 
                                            border: '1px solid #d6a400', 
                                            '& .MuiAlert-icon': { color: '#d6a400' } 
                                        }}
                                    >
                                        <AlertTitle sx={{ fontWeight: 'bold', color: '#856404' }}>
                                            Refaturamento não permitido
                                        </AlertTitle>
                                        <Typography variant="body2" sx={{ color: '#533f03' }}>
                                            {descricaoRefaturamento || "Esta fatura não é elegível para refaturamento."}
                                        </Typography>
                                    </Alert>
                                )}

                                {permiteRefaturamento && descricaoRefaturamento && (
                                    <Alert 
                                        severity="success" 
                                        sx={{ 
                                            mb: 2, 
                                            backgroundColor: '#d4edda', 
                                            border: '1px solid #28a745', 
                                            '& .MuiAlert-icon': { color: '#28a745' } 
                                        }}
                                    >
                                        <AlertTitle sx={{ fontWeight: 'bold', color: '#155724' }}>
                                            Refaturamento permitido
                                        </AlertTitle>
                                        <Typography variant="body2" sx={{ color: '#155724' }}>
                                            {descricaoRefaturamento}
                                        </Typography>
                                    </Alert>
                                )}

                                {errosElegibilidade.length > 0 && (
                                    <Alert severity="error" sx={{ mb: 2, fontFamily: "'Lato', sans-serif" }}>
                                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                                            {errosElegibilidade.map((erro, index) => (
                                                <li key={index}>{erro}</li>
                                            ))}
                                        </ul>
                                    </Alert>
                                )}

                                <Typography variant="h5">Atenção:</Typography>
                                <Typography variant="body2">
                                    * AO REABRIR UMA FATURA, VOCÊ TAMBÉM ESTARÁ CANCELANDO A FATURA DE CLIENTE!
                                </Typography>
                                <Dashed />
                                <Box>
                                    <Box>
                                        <Grid>
                                            <Typography variant="subtitle2">Fatura Instalação ID: {idProp?.id}</Typography>
                                            <Typography variant="subtitle2">Num. Instalação: {idProp?.numeroInstalacao}</Typography>
                                            <Typography variant="subtitle2">Ciclo: {idProp?.cicloFaturamento}</Typography>
                                        </Grid>
     
                                        <Grid container spacing={1}>
                                            <TextInput
                                                name="motivo"
                                                label="Descreva o Motivo"
                                                control={control}
                                                error={errors}
                                                multiline
                                                maxLength={150}
                                            />
                                        </Grid>
                                    </Box>
                                    <Box></Box>
                                </Box>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button 
                            onClick={() => onCancelReopen()} 
                            color="warning" 
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDisable || loadingElegibilidade || !permiteRefaturamento}
                            style={{ width: "159px", height: "44px" }}
                            id="btnConfirmar"
                        >
                            Confirmar
                        </Button>

                        <DialogConfirm
                            open={openModalFaturaPaga}
                            title={"Reabrir Fatura: Retorno Sankhya"}
                            message={
                                "O Sankhya retornou a seguinte mensagem: '" + (msgRetornoPendenciaSankhya ? 
                                msgRetornoPendenciaSankhya : "") + "'. Deseja continuar com a Reabertura mesmo assim?"
                            }
                            cancelButtonText={"Cancelar"}
                            confirmButtonText={"Confirmar"}
                            onClose={() => setOpenModalFaturaPaga(false)}
                            onCancel={() => {
                                setProsseguirPendenciaSankhya(false);
                                setOpenModalFaturaPaga(false);
                                setMsgRetornoPendenciaSankhya("");
                                onClose(true);
                            }}
                            onConfirm={() => {
                                setProsseguirPendenciaSankhya(true);
                                setOpenModalFaturaPaga(false);
                                setMsgRetornoPendenciaSankhya("");

                                setTimeout(() => {
                                    const el =  document.getElementById("btnConfirmar") as HTMLElement;

                                    if (el) {
                                        el.click();
                                    }
                                }, 500);
                            }}
                        />
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
